import React from "react";
import "../SCSS/LoadingPage.scss";

const Loading = () => {
  return (
    <div className="loading-container">
      <div className="loading-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <p className="loading-text">Loading...</p>
    </div>
  );
};

export default Loading;
